import { CannabinoidStoreMarketplace } from "src-next/modules/patient-supporting-documents/marketplace";
import type { ReactNode } from "react";

interface CannabinoidMarketplacePanelProps {
  userEmail: string;
  patientId?: string;
  userPatient?: unknown;
  userName?: string;
  hideHeader?: boolean;
  /** false = bloqueia lojas; pedidos existentes continuam acessíveis. */
  canBrowseStores?: boolean;
  documentsPendingCount?: number;
  onHeaderActionsChange?: (actions: ReactNode | null) => void;
}

/**
 * Container legado do marketplace canabinoide — modo inline na página.
 */
export function CannabinoidMarketplacePanel({
  userEmail,
  patientId,
  userPatient,
  userName,
  hideHeader = false,
  canBrowseStores = true,
  documentsPendingCount = 0,
  onHeaderActionsChange,
}: CannabinoidMarketplacePanelProps) {
  return (
    <CannabinoidStoreMarketplace
      userEmail={userEmail}
      patientId={patientId}
      userPatient={userPatient}
      userName={userName}
      inline
      hideHeader={hideHeader}
      canBrowseStores={canBrowseStores}
      documentsPendingCount={documentsPendingCount}
      onHeaderActionsChange={onHeaderActionsChange}
    />
  );
}
